import { Translatable } from '@app/types/translatable.type';

const CalendarFeedDisplayOptions: { [key: string]: Translatable } = {
    'Company Time Off': 'company.calendar-feeds.companyTimeOff',
    'Department Time Off': 'company.calendar-feeds.departmentTimeOff',
    'My Time Off': 'company.calendar-feeds.myTimeOff',
    Anniversaries: 'company.calendar-feeds.anniversaries',
    Birthdays: 'company.calendar-feeds.birthdays',
};

const CalendarFeedDescriptionDisplayOptions: { [key: string]: Translatable } = {
    'All approved time off requests with details about leave type and reasons given (if allowed by Type visibility settings)':
        'company.calendar-feeds.allApprovedCompanyTimeOff',
    'All approved time off requests from everyone in your department.':
        'company.calendar-feeds.allApprovedDepartmentTimeOff',
    "All approved requests from you and anyone who reports to you. This also includes the company's holidays.":
        'company.calendar-feeds.allYourApprovedTimeOffRequests',
    "A feed of all employee's anniversaries": 'company.calendar-feeds.aFeedOfAllEmployeesAnniversaries',
    "A feed of all employee's birthdays": 'company.calendar-feeds.aFeedOfAllEmployeesBirthdays',
};

export { CalendarFeedDisplayOptions, CalendarFeedDescriptionDisplayOptions };
